// Now that it has been made like this, it needs to be updated again

$(document).ready(function() {
  $('.next-page-link').not(':last').remove();
  $.fn.scrollWindow = function(options, asd)
  {
    var settings = $.extend({
      trigger : false,
      container: $(this),
      selector: false,
      distance : 0,
      start : function(){},
      complete : function(){},
      debug : false
    }, options);

    var scope = $(this);
    var loading = false;

    var log = function(obj) { if (settings.debug && console.log != undefined) { console.log(obj); } }
    log('initialized');
    log(scope);
    log(settings);

    $(this).on('click', settings.trigger, function(){
      log('triggered');
      settings.start();
      loading = true;
      var url = scope.find(settings.trigger).attr('href');
      log('requesting: ' + url);
      $('<div></div>').load(url, function() {
        var newScope = $(this);
        scope.find(settings.trigger).replaceWith(newScope.find(settings.trigger).first());
        scope.find(settings.container).append(newScope.find(settings.selector));
        loading = false;
        log('done');
        settings.complete();
      });
      return false;
    });

    if (settings.distance)
    {
      $(window).on('scroll',function(){
        // console.log(`ScrollTop Height ${$(document).scrollTop()}, DocumentHeight ${$(document).height()}, Window Height ${$(window).height()}, Calculate ${($(document).height() - $(window).height() - settings.distance)}`)
        if ($(document).scrollTop() >= ($(document).height() - $(window).height() - settings.distance))
        {
          if (!loading)
          {
            $(settings.trigger).trigger('click');
          }
        }
      });
    }
  };

  $('#scope').scrollWindow({
    // selector of the trigger link
    trigger:'.next-page-link',
    // element where next page items are going to be added
    container: '#item-lists',
    // elements to be added to the page
    selector:'.item-list',
    // distance from the bottom of the page to load more data
    distance: 10,
    // callback called when a new page is loading
    start: function(){
      $(this.container).append("<div class='text-center' id='text-loading'><div class='spinner-border'></div></div>")
    },
    // fired when the page is loaded
    complete: function(){
      var total_records = document.querySelector('#total-records');
      if (total_records != null) {
        total_records.textContent = document.querySelectorAll('.item').length;
      }

      $('#text-loading').remove()
      $('.next-page-link').not(':last').remove();
    },
  });
})
